import { combineReducers } from 'redux';
import { authentication } from "./user";
import layouts from "./layouts";
const reducers = combineReducers({
    layouts,
    authentication,
});

export default reducers;